/**
 * Import Dependency
 */
import React, { Component } from 'react'
// import ReactSwiper from 'react-id-swiper'
import { Grid } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import styles from '../assets/styles/components/Grid'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class GridComponent extends Component {
  renderSwiperItems = () => {
    const { classes } = this.props
    const gridItemWrapStyle = cx(classes['grid-item-wrap'])
    const gridItemDetailStyle = cx(classes['grid-item-detail'])
    const gridItems = this.props.gridItems
    const itemClick = this.props.itemClick

    return (
      <Grid
        data={gridItems}
        columnNum={4}
        hasLine={false}
        renderItem={(element, index) => (
          <div
            className={gridItemWrapStyle}
            style={{
              background: `url(${element.image})`,
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #fff',
            }}
            onClick={() => itemClick(element)}
          >
            <div className={gridItemDetailStyle}>
              {element.name}
            </div>
          </div>
        )}
      />
    )
  }

  render () {
    const { classes } = this.props
    const wrapStyle = cx(classes.wrap)

    return (
      <div className={wrapStyle}>
        {this.renderSwiperItems()}
      </div>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(GridComponent)



// WEBPACK FOOTER //
// ./src/components/Grid.js